export default {
  development: require('./development'),
  develop: require('./develop'),
  staging: require('./staging'),
  production: require('./production'),
  release: require('./release')
}
